import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var StreetSignIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("g", {
                            clipPath: "url(#street-sign__a)",
                            children: _jsx("path", {
                                d: "M22.875 8.925a1.65 1.65 0 00-.39-.58l-2.39-2.39c-.34-.34-.79-.52-1.27-.52h-5.83v-3.78c0-.55-.45-1-1-1h-6.83c-.48 0-.93.19-1.27.53l-2.39 2.38a1.81 1.81 0 00-.53 1.27c0 .24.05.47.14.69.09.22.22.42.39.58l2.39 2.39c.34.34.79.52 1.27.52h5.84v1.18h-5.84c-.48 0-.93.19-1.27.53l-2.39 2.39a1.81 1.81 0 00-.53 1.27c0 .24.05.47.14.69.09.22.22.42.39.58l2.39 2.39c.34.34.79.52 1.27.52h5.84v3.78c0 .55.45 1 1 1s1-.45 1-1v-8.55h5.83c.48 0 .93-.19 1.27-.53l2.39-2.39a1.81 1.81 0 00.53-1.27c0-.24-.05-.47-.14-.69l-.01.01zm-17.63-1.91l-2.18-2.18 2.18-2.18h5.75v4.37h-5.75v-.01zm0 9.55l-2.18-2.18 2.18-2.18h5.75v4.37h-5.75v-.01zm13.5-4.78h-5.75v-4.37h5.75l2.18 2.18-2.18 2.18v.01z"
                            })
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "street-sign__a",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
StreetSignIcon.isCarinaIcon = true;
export default StreetSignIcon;
